import PasswordChange from './PasswordChange'

export default PasswordChange



// WEBPACK FOOTER //
// ./src/views/PasswordChange/index.js